<app-ui-button
  buttonType="icon-button"
  icon="event"
  [matMenuTriggerFor]="customRangeMenu"
  #customRangeTrigger="matMenuTrigger"
  (menuOpened)="onMenuOpened(customRangeTrigger)"
  class="custom-range-button"
  [tooltip]="tooltipKey | translate"
></app-ui-button>
@if (hasCustomRange) {
  <div class="custom-range-chip">
    <span class="chip-text">{{ customRangeDisplayText }}</span>
    <app-ui-button
      buttonType="icon-button"
      icon="cancel"
      class="chip-remove-button"
      (click)="clearCustomRange()"
      [tooltip]="removeTooltipKey | translate"
    ></app-ui-button>
  </div>
}
<mat-menu #customRangeMenu="matMenu" class="custom-range-menu">
  <div
    class="custom-range-picker"
    (click)="$event.stopPropagation()"
    (mousedown)="$event.stopPropagation()"
  >
    <div
      class="date-inputs"
      (click)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()"
    >
      <app-shared-ui-datepicker
        [label]="fromLabelKey | translate"
        [control]="fromControl"
        [max]="getFromMaxDate()"
        [required]="false"
      ></app-shared-ui-datepicker>
      <app-shared-ui-datepicker
        [label]="toLabelKey | translate"
        [control]="toControl"
        [min]="getToMinDate()"
        [max]="maxDate"
        [required]="false"
      ></app-shared-ui-datepicker>
    </div>
    <div class="custom-range-actions">
      <app-ui-button
        buttonType="secondary"
        text="{{ cancelKey | translate }}"
        (click)="cancelCustomRange()"
      ></app-ui-button>
      <app-ui-button
        color="primary"
        text="{{ applyKey | translate }}"
        (click)="applyCustomRange()"
        [disabled]="!isCustomRangeValid()"
      ></app-ui-button>
    </div>
  </div>
</mat-menu>
